<template lang="html">
  <div class="diak-adatok-component">
    <v-container>
      <v-progress-linear
            v-if="!studentdetails"
            indeterminate
            color="red"
      ></v-progress-linear>
      <v-form
        ref="diak_adat_form"
        v-model="valid"
        v-show="studentdetails"
        lazy-validation
      >
      <br>
      <div class="subtitle-1">Személyes adatok</div>
      <v-divider></v-divider><br>
      <v-row>
        <v-col class="d-flex" cols="12" sm="6" md="3">
          <v-select
            :items="title_options"
            :value="title"
            @change="title = $event"
            label="Titulus választása"
            outlined
            append-icon="school"
            :disabled="archived"
          ></v-select>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6" md="3">
          <v-text-field
            v-model="last_name"
            label="Vezetéknév"
            :rules="[rules.required]"
            outlined
            :disabled="archived"
          ></v-text-field>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6" md="3">
          <v-text-field
            v-model="first_name"
            label="Keresztnév"
            :rules="[rules.required]"
            outlined
            :disabled="archived"
            @change="preSearch"
          ></v-text-field>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6" md="3">
          <v-text-field
            :value="middle_name"
            @change="middle_name = $event"
            label="Utónév"
            outlined
            :disabled="archived"
          ></v-text-field>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6" md="4">
          <v-text-field
            :value="FullName"
            label="Teljes név"
            outlined
            :disabled="archived"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <v-select
            :value="gender"
            @change="gender = $event"
            :items="gender_items"
            label="Neme"
            outlined
            :rules="[rules.required]"
          ></v-select>
        </v-col>
        <v-col cols="12" md="4">
          <v-select
            :value="education"
            @change="education = $event"
            :items="education_items"
            label="Iskolai végzettség"
            outlined
            :rules="[rules.required]"
          ></v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-btn
            color="primary"
            @click="copyBirthName"
            rounded
          >
          Név másolása
          </v-btn>
      </v-col>
      </v-row>

      <v-row>
      <v-col class="d-flex" cols="12" sm="6" md="4">
        <v-text-field
          :value="birth_last_name"
          @change="birth_last_name = $event"
          label="Születési vezetéknév"
          :rules="[rules.required]"
          outlined
          :disabled="archived"
        ></v-text-field>
      </v-col>
      <v-col class="d-flex" cols="12" sm="6" md="4">
        <v-text-field
          :value="birth_first_name"
          @change="birth_first_name = $event"
          label="Születési keresztnév"
          :rules="[rules.required]"
          outlined
          :disabled="archived"
        ></v-text-field>
      </v-col>
      <v-col class="d-flex" cols="12" sm="6" md="4">
        <v-text-field
          :value="birth_middle_name"
          @change="birth_middle_name = $event"
          label="Születési utónév"
          outlined
          :disabled="archived"
        ></v-text-field>
      </v-col>
      </v-row>

      <v-row>
        <v-col class="d-flex" cols="12" sm="6" md="3">
          <v-text-field
            :value="country_of_birth"
            @change="country_of_birth = $event"
            label="Születési ország"
            hint="Csak akkor szükséges, ha nem Magyarország!"
            append-icon="public"
            outlined
            :disabled="archived"
          ></v-text-field>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6" md="3">
          <v-text-field
            :value="place_of_birth"
            @change="place_of_birth = $event"
            label="Születési hely"
            :rules="[rules.required]"
            append-icon="room"
            outlined
            counter
            maxlength="27"
            :disabled="archived"
          ></v-text-field>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6" md="3">
          <v-text-field
            v-model="birthdate"
            v-mask="'####-##-##'"
            hint="formátum: éééé-hh-nn"
            label="Születési idő"
            :rules="birthdateRules"
            append-icon="date_range"
            outlined
            :disabled="archived"
          ></v-text-field>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6" md="3">
          <v-select
            :value="nationality"
            @change="nationality = $event"
            :items="nationality_list"
            item-text="label"
            item-value="label"
            label="Nemzetiség"
            append-icon="language"
            :rules="[rules.required]"
            outlined
            :disabled="archived"
          ></v-select>
        </v-col>
      </v-row>

      <v-row>
        <v-col class="d-flex" cols="12" sm="6" md="4">
          <v-text-field
            :value="mother_last_name"
            @change="mother_last_name = $event"
            label="Anyja vezetéknév"
            :rules="[rules.required]"
            outlined
            :disabled="archived"
          ></v-text-field>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6" md="4">
          <v-text-field
            :value="mother_first_name"
            @change="mother_first_name = $event"
            label="Anyja keresztnév"
            :rules="[rules.required]"
            outlined
            :disabled="archived"
          ></v-text-field>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6" md="4">
          <v-text-field
            :value="mother_middle_name"
            @change="mother_middle_name = $event"
            label="Anyja utónév"
            outlined
            :disabled="archived"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="4">
          <v-text-field
            :value="identity_card_number"
            @change="identity_card_number = $event"
            label="Személyi igazolvány száma"
            :rules="[rules.required]"
            append-icon="credit_card"
            outlined
            :disabled="archived"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <v-select
            :value="okirat_type"
            @change="okirat_type = $event"
            :items="okirat_types"
            item-value="code"
            item-text="type"
            label="Okmány típusa"
            outlined
            :rules="[rules.required]"
          ></v-select>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            :value="address_card_number"
            @change="address_card_number = $event"
            label="Lakcímkártya száma"
            hint="Csak GKI képzés esetén kötelező"
            persistent-hint
            outlined
            :disabled="archived"
          ></v-text-field>
        </v-col>
        </v-row>

        <v-row>
        <v-col cols="12" md="4">
          <v-text-field
            :value="tax_code"
            @change="tax_code = $event"
            label="Adóazonosító jel"
            outlined
            :disabled="archived || no_tax"
            v-mask="'##########'"
            hint="formátum: 0123456789"
            :rules="[taxcodeRules.tax_format]"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <v-tooltip top>
          <template v-slot:activator="{ on }">
          <v-checkbox
          v-model="no_tax"
          label="Adószám letiltása"
          v-on="on"
          >
          </v-checkbox>
          </template>
          <span>Letiltás esetén a tanulói szerződés 1. oldalának végére rákerül egy nyilatkozat, hogy nem járul hozzá.</span>
        </v-tooltip>
        </v-col>
      </v-row>

      <div class="subtitle-1">Kapcsolati adatok</div>
      <v-divider></v-divider><br>

      <v-row>
        <v-col class="d-flex" cols="12" md="4">
          <v-text-field
            :value="email1"
            @change="email1 = $event"
            label="E-mail"
            :rules="[rules.email]"
            append-icon="email"
            outlined
            :disabled="archived"
          ></v-text-field>
        </v-col>
        <v-col class="d-flex" cols="12" md="4">
          <v-text-field
            :value="phone1"
            @change="phone1 = $event"
            label="Telefonszám"
            append-icon="phone"
            outlined
            hint="formátum: 367012345678"
            persistent-hint
            :rules="phone_rules"
            :disabled="archived"
          ></v-text-field>
        </v-col>
        <v-col class="d-flex" cols="12" md="4">
          <v-checkbox
          v-model="foreign_number"
          label="Külföldi szám"
          >
          </v-checkbox>
        </v-col>
      </v-row>
      <v-row v-if="!check18">
        <v-col class="d-flex" cols="12" md="4">
          <v-text-field
            :value="parent_email"
            @change="parent_email = $event"
            label="Szülői e-mail cím"
            append-icon="email"
            prepend-inner-icon="escalator_warning"
            outlined
            :rules="[rules.email]"
            :disabled="archived"
          ></v-text-field>
        </v-col>
        <v-col class="d-flex" cols="12" md="4">
          <v-text-field
            :value="parent_phone"
            @change="parent_phone = $event"
            label="Szülői telefonszám"
            append-icon="phone"
            prepend-inner-icon="escalator_warning"
            outlined
            hint="formátum: 367012345678"
            persistent-hint
            :disabled="archived"
          ></v-text-field>
        </v-col>
      </v-row>
        <div class="subtitle-1">Állandó lakcím</div>
      <v-row>
        <v-col class="d-flex" cols="12" sm="6" md="4">
          <v-select
            :value="per_country"
            @change="per_country = $event"
            :items="country_list"
            item-text="country"
            item-value="country"
            label="Ország"
            :rules="[rules.required]"
            outlined
            :disabled="archived"
          ></v-select>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6" md="4">
          <v-text-field
            :value="per_zip"
            @change="per_zip = $event, getPerCityName($event)"
            v-mask="'####'"
            label="Irányítószám"
            :rules="[rules.required]"
            outlined
            :disabled="archived"
          ></v-text-field>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6" md="4">
          <v-text-field
            v-model="per_city"
            :rules="[rules.required]"
            label="Város"
            outlined
            :loading = "per_city_load"
            :disabled="archived"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col class="d-flex" cols="12" sm="6" md="4">
          <v-text-field
            :value="per_public_premises"
            @change="per_public_premises = $event"
            label="Közterület"
            :rules="[rules.required]"
            outlined
            :disabled="archived"
          ></v-text-field>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6" md="4">
          <v-autocomplete
            :value="per_type_of_public_premises"
            @change="per_type_of_public_premises = $event"
            :items="publicpermises"
            item-text="label"
            item-value="label"
            label="Közterület típusa"
            :rules="[rules.required]"
            outlined
            :disabled="archived"
          ></v-autocomplete>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6" md="4">
          <v-text-field
            :value="per_house_number"
            @change="per_house_number = $event"
            label="Házszám"
            :rules="[rules.required]"
            outlined
            :disabled="archived"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col class="d-flex" cols="12" sm="6" md="3">
          <v-text-field
            :value="per_building_number"
            @change="per_building_number = $event"
            label="Épület"
            outlined
            :disabled="archived"
          ></v-text-field>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6" md="3">
          <v-text-field
            :value="per_stairway_number"
            @change="per_stairway_number = $event"
            label="Lépcsőház"
            outlined
            :disabled="archived"
          ></v-text-field>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6" md="3">
          <v-text-field
            :value="per_floor_number"
            @change="per_floor_number = $event"
            label="Emelet"
            outlined
            :disabled="archived"
          ></v-text-field>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6" md="3">
          <v-text-field
            :value="per_door_number"
            @change="per_door_number = $event"
            label="Ajtó"
            outlined
            :disabled="archived"
          ></v-text-field>
        </v-col>
        <v-col>
          <v-btn
            color="primary"
            @click="copyAddress"
            rounded
          >
          Lakcím másolása
          </v-btn>
      </v-col>
      </v-row>

      <div class="subtitle-1">Értesítési lakcím</div>
    <v-row>
      <v-col class="d-flex" cols="12" sm="6" md="4">
        <v-select
          :value="temp_country"
          @change="temp_country = $event"
          :items="country_list"
          item-text="country"
          item-value="country"
          label="Ország"
          :rules="[rules.required]"
          outlined
          :disabled="archived"
        ></v-select>
      </v-col>
      <v-col class="d-flex" cols="12" sm="6" md="4">
        <v-text-field
          :value="temp_zip"
          @change="temp_zip = $event, getTempCityName($event)"
          v-mask="'####'"
          label="Irányítószám"
          :rules="[rules.required]"
          outlined
          :disabled="archived"
        ></v-text-field>
      </v-col>
      <v-col class="d-flex" cols="12" sm="6" md="4">
        <v-text-field
          v-model="temp_city"
          :rules="[rules.required]"
          label="Város"
          outlined
          :loading = "temp_city_load"
          :disabled="archived"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col class="d-flex" cols="12" sm="6" md="4">
        <v-text-field
          :value="temp_public_premises"
          @change="temp_public_premises = $event"
          label="Közterület"
          :rules="[rules.required]"
          outlined
          :disabled="archived"
        ></v-text-field>
      </v-col>
      <v-col class="d-flex" cols="12" sm="6" md="4">
        <v-autocomplete
          :value="temp_type_of_public_premises"
          @change="temp_type_of_public_premises = $event"
          :items="publicpermises"
          item-text="label"
          item-value="label"
          label="Közterület típusa"
          :rules="[rules.required]"
          outlined
          :disabled="archived"
        ></v-autocomplete>
      </v-col>
      <v-col class="d-flex" cols="12" sm="6" md="4">
        <v-text-field
          :value="temp_house_number"
          @change="temp_house_number = $event"
          label="Házszám"
          :rules="[rules.required]"
          outlined
          :disabled="archived"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col class="d-flex" cols="12" sm="6" md="3">
        <v-text-field
          :value="temp_building_number"
          @change="temp_building_number = $event"
          label="Épület"
          outlined
          :disabled="archived"
        ></v-text-field>
      </v-col>
      <v-col class="d-flex" cols="12" sm="6" md="3">
        <v-text-field
          :value="temp_stairway_number"
          @change="temp_stairway_number = $event"
          label="Lépcsőház"
          outlined
          :disabled="archived"
        ></v-text-field>
      </v-col>
      <v-col class="d-flex" cols="12" sm="6" md="3">
        <v-text-field
          :value="temp_floor_number"
          @change="temp_floor_number = $event"
          label="Emelet"
          outlined
          :disabled="archived"
        ></v-text-field>
      </v-col>
      <v-col class="d-flex" cols="12" sm="6" md="3">
        <v-text-field
          :value="temp_door_number"
          @change="temp_door_number = $event"
          label="Ajtó"
          outlined
          :disabled="archived"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row v-if="customer_id">
      <v-col cols="12" md="4">
          <v-checkbox
            v-model="billing_address"
            label="Eltérő számlázási adatok"
          ></v-checkbox>
      </v-col>
    </v-row>

    <div class="billing_address" v-if="billing_address && customer_id">
      <div class="subtitle-1">Számlázási adatok</div>
      <v-row>
        <v-col cols="12" md="8">
          <v-text-field
            :value="bill_name"
            @change="bill_name = $event"
            label="Név"
            :rules="[rules.required]"
            outlined
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            :value="taxcode"
            @change="taxcode = $event"
            label="Adószám"
            outlined
            :rules="tax_code_rules"
            :disabled="taxCodeDisabled || no_company"
            v-mask="'########-#-##'"
            masked="false"
          >
        </v-text-field>
        <v-checkbox
        v-model="no_company"
        label="Magánszemély"
        dense
        ></v-checkbox>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="d-flex" cols="12" sm="6" md="4">
          <v-select
            :value="bill_country"
            @change="bill_country = $event"
            :items="country_list"
            item-text="country"
            item-value="country"
            label="Ország"
            :rules="[rules.required]"
            outlined

          ></v-select>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6" md="4">
          <v-text-field
            :value="bill_zip"
            @change="bill_zip = $event, getBillCityName($event)"
            v-mask="'####'"
            label="Irányítószám"
            :rules="[rules.required]"
            outlined
          ></v-text-field>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6" md="4">
          <v-text-field
            v-model="bill_city"
            :rules="[rules.required]"
            label="Város"
            outlined
            :loading = "bill_city_load"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col class="d-flex" cols="12" sm="6" md="4">
          <v-text-field
            :value="bill_public_premises"
            @change="bill_public_premises = $event"
            label="Közterület"
            :rules="[rules.required]"
            outlined

          ></v-text-field>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6" md="4">
          <v-autocomplete
            :value="bill_type_of_public_premises"
            @change="bill_type_of_public_premises = $event"
            :items="publicpermises"
            item-text="label"
            item-value="label"
            label="Közterület típusa"
            :rules="[rules.required]"
            outlined

          ></v-autocomplete>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6" md="4">
          <v-text-field
            :value="bill_house_number"
            @change="bill_house_number = $event"
            label="Házszám"
            :rules="[rules.required]"
            outlined

          ></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col class="d-flex" cols="12" sm="6" md="3">
          <v-text-field
            :value="bill_building_number"
            @change="bill_building_number = $event"
            label="Épület"
            outlined

          ></v-text-field>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6" md="3">
          <v-text-field
            :value="bill_stairway_number"
            @change="bill_stairway_number = $event"
            label="Lépcsőház"
            outlined

          ></v-text-field>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6" md="3">
          <v-text-field
            :value="bill_floor_number"
            @change="bill_floor_number = $event"
            label="Emelet"
            outlined

          ></v-text-field>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6" md="3">
          <v-text-field
            :value="bill_door_number"
            @change="bill_door_number = $event"
            label="Ajtó"
            outlined

          ></v-text-field>
        </v-col>
      </v-row>
    </div>

    <v-row>
      <v-col>
        <v-textarea
          :value="description"
          @change="description = $event"
          outlined
          label="Megjegyzés"
          :disabled="archived"
        ></v-textarea>
      </v-col>
    </v-row>

<v-row>
  <v-col md="6">
    <v-btn
      v-if="!customer_id"
      :disabled="!last_name || !first_name || !birthdate"
      color="primary"
      class="mr-4"
      @click="save_student_dialog = true"
      rounded
    >
    Rögzít
    </v-btn>
    <v-btn
      v-if="customer_id"
      color="primary"
      class="mr-4"
      @click="save_student_dialog = true"
      rounded
    >
    Módosít
    </v-btn>
    <v-btn
      :disabled="!valid"
      color="primary"
      class="mr-4"
      @click="getStudentDetails()"
      rounded
    >
    Mégsem
    </v-btn>
  </v-col>
  </v-row>
  <v-row>
<v-col md="4">
  <v-btn
    v-if="customer_id && !archived"
    color="primary"
    class="mr-4"
    @click="archvie_student_dialog = true"
    rounded
  >
  Archiválás
  </v-btn>
  <v-btn
    v-if="customer_id && archived"
    color="primary"
    class="mr-4"
    @click="active_student_dialog = true"
    rounded
  >
  Aktiválás
  </v-btn>
</v-col>
<v-col md="4" v-if="contract_type == 4">
  <v-btn
    color="primary"
    class="mr-4"
    @click="gkiPortalReg"
    outlined
    rounded
  >
  GKI Portál
  </v-btn>
</v-col>
</v-row>

<v-snackbar v-model="create_student_snackbar" bottom :color="!student_save_success ? 'error' : ''">
  {{student_save_result}}
  <v-btn :color="!student_save_success ? '' : 'pink'" text @click="create_student_snackbar = false">
    Bezár
  </v-btn>
</v-snackbar>

<v-dialog v-model="archvie_student_dialog" persistent max-width="350">
  <v-card>
    <v-card-text class="pt-4">Biztosan archiválni szeretné a tanulót?</v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="red" text @click="archvie_student_dialog = false">Nem</v-btn>
      <v-btn color="green" text @click="archiveStudent(archived = 'true'), archvie_student_dialog = false">Igen</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

<v-dialog v-model="active_student_dialog" persistent max-width="290">
  <v-card>
    <v-card-text class="pt-4">Biztosan aktiválni szeretné a tanulót?</v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="red" text @click="active_student_dialog = false">Nem</v-btn>
      <v-btn color="green" text @click="archiveStudent(archived = 'false'), active_student_dialog = false">Igen</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

<v-dialog v-model="save_student_dialog" persistent max-width="290">
  <v-card>
    <v-card-text class="pt-4">
      Biztosan menteni szeretne?
      <br><br>
      <p v-if="!valid" class="red--text"><b>Nincs minden kötelező adat kitöltve!</b></p>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" text @click="saveStudent(), save_student_dialog = false">Igen</v-btn>
      <v-btn color="primary" text @click="save_student_dialog = false">Nem</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

   </v-form>
  </v-container>

  <v-dialog v-model="pallasz_dialog" persistent max-width="600">
    <v-card>
      <v-container>
      <p><b>Szeretné a változást a KAV rendszerében is rögzíteni?</b></p>
      <v-simple-table>
          <thead>
            <tr>
              <th class="text-left">
                Tanuló azonosító
              </th>
              <th class="text-left">
                Tanfolyam kezdete
              </th>
              <th class="text-left">
                Tanfolyam vége
              </th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="item in pallasz_ids"
              :key="item.pallasz_id"
            >
              <td>{{ item.course_student_id }}</td>
              <td>{{ item.start_date }}</td>
              <td>{{ item.end_date }}</td>
              <td>
                <v-btn color="green" outlined @click="pallaszUpdate(item.pallasz_id, item.course_data_id), pallaszOkmUpdate(item.pallasz_id, item.course_data_id)" :loading="preloader" :disabled="preloader">rögzít</v-btn>
              </td>
            </tr>
          </tbody>
      </v-simple-table>
      <v-card-actions>
        <v-btn color="red" outlined @click="pallasz_dialog = false">bezár</v-btn>
      </v-card-actions>
      </v-container>
    </v-card>
  </v-dialog>

  <v-bottom-sheet v-model="presearch_sheet" scrollable>
      <v-card>
        <v-card-text>
          <div class="py-3">A rendszerben már szerepel tanuló ezzel a névvel. Amennyiben egyezést talál, válassza ki a tanuló adatlapját az adatok újrarögzítése helyett!</div>
          <v-data-table
            :headers="existing_students_headers"
            :items="existing_students"
            :items-per-page="5"
            dense
            @click:row="selectFromPresearch($event.customer_id)"
            :mobile-breakpoint='NaN'
          ></v-data-table>
        </v-card-text>
      </v-card>
  </v-bottom-sheet>

  </div>
</template>

<script>
import store from '../store'

import {
  mapFields
} from 'vuex-map-fields'


export default {
  data () {
    return {
      studentdetails: '',
      title: '',
      last_name: '',
      first_name: '',
      middle_name: '',
      birth_last_name: '',
      birth_middle_name: '',
      birth_first_name: '',
      place_of_birth: '',
      country_of_birth: '',
      nationality: '',
      mother_last_name: '',
      mother_first_name: '',
      mother_middle_name: '',
      per_country: '',
      per_zip: '',
      per_city: '',
      per_type_of_public_premises: '',
      per_public_premises: '',
      per_house_number: '',
      per_building_number: '',
      per_stairway_number: '',
      per_floor_number: '',
      per_door_number: '',
      temp_country: '',
      temp_zip: '',
      temp_city: '',
      temp_type_of_public_premises: '',
      temp_public_premises: '',
      temp_house_number: '',
      temp_building_number: '',
      temp_stairway_number: '',
      temp_floor_number: '',
      temp_door_number: '',
      identity_card_number: '',
      description: '',
      archvie_student_dialog: false,
      active_student_dialog: false,
      save_student_dialog: false,
      student_save_result: '',
      create_student_snackbar: false,
      student_delete_result: '',
      student_delete_snackbar: false,
      valid: true,
      title_options: [
        { text: '', value: ''},
        { text: 'Dr.', value: 'Dr.'},
        { text: 'dr.', value: 'dr.'},
      ],
      gender_items: [
        { text: 'Férfi', value: "1"},
        { text: 'Nő', value: "2"},
      ],
      education_items: [
        { text: 'Végzettség nélkül', value: "1"},
        { text: 'Általános iskolai végzettség', value: "2"},
        { text: 'Középfokú végzettség és gimnáziumi érettségi (gimnázium)', value: "3"},
        { text: 'Középfokú végzettség és középfokú szakképesítés (szakgimnázium, szakképző iskola, szakiskola)', value: "4"},
        { text: 'Középfokú végzettség és középfokú szakképzettség (technikum)', value: "5"},
        { text: 'Felsőfokú végzettségi szint és felsőfokú szakképzettség (felsőoktatási intézmény)', value: "6"},
        { text: 'Felsőoktatási szakképzés (felsőoktatási intézmény)', value: "7"},
      ],
      gender: '',
      education: '',
      tax_code: '',
      publicpermises: [],
      per_city_load: false,
      temp_city_load: false,
      country_list: [],
      nationality_list: [],
      presearch_sheet: false,
      rules: {
          required: value => !!value || 'Kötelező mező!',
          email: value => {
            if(value != null) {
              const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
              return pattern.test(value) || 'Hibás e-mail cím!'
            }
          },
        },
        birthdateRules: [
            v => !!v || 'Kötelező mező!',
            v => /(\d{4})-(\d{2})-(\d{2})/.test(v) || 'Hibás születési dátum!',
        ],
        taxcodeRules: {
          tax_format: value => {
            if(value != '') {
             return /\d{10}/.test(value) || 'Hibás adóazonosító!'
          }
         }
        },
        phone_rules: [
          value => (this.foreign_number == true || /36\d{8,9}$/.test(value)) || 'Hibás telefonszám formátum! (helyes alak: 367012345678)',
        ],
        foreign_number: false,
        existing_students_headers: [
          { text: 'Név', value: 'name', width: 150},
          { text: 'Születési idő', value: 'birthdate', width: 130},
          { text: 'Telefonszám', value: 'phone1', width: 130},
          { text: 'E-mail cím', value: 'email1', width: 130},
          { text: 'Ügyfél típus', value: 'customer_type', width: 120},
        ],
        existing_students: [],
        student_save_success: '',
        no_tax: false,
        okirat_types: [],
        okirat_type: '',
        address_card_number: '',
        pallasz_dialog: false,
        pallasz_ids: [],
        billing_address: false,
        bill_country: '',
        bill_zip: '',
        bill_city: '',
        bill_public_premises: '',
        bill_type_of_public_premises: '',
        bill_house_number: '',
        bill_building_number: '',
        bill_stairway_number: '',
        bill_floor_number: '',
        bill_door_number: '',
        bill_name: '',
        taxcode: '',
        tax_code_rules: [
          value => (this.bill_name == this.full_name || this.no_company == true || !!value) || 'Céges vevő esetén kötelező!',
          value => (this.bill_name == this.full_name || this.no_company == true || /\d\d\d\d\d\d\d\d-\d-\d\d/.test(value)) || 'Hibás adószám formátum!',
        ],
        no_company: false,
        parent_email: '',
        parent_phone: '',
        registration_date: '',
      }
  },
  methods: {
    getStudentDetails: async function() {
      this.studentdetails = null
      await this.gettoken()
      store.state.showing.preloader = true
      this.$http.post('/diakok/diakok_adatok', {
        token: this.token,
        contract_id: this.contract_id,
        customer_id: this.customer_id,
      }).then((response) => {
        this.studentdetails = response.data;
        store.state.showing.preloader = false
        this.title = response.data[0]['title']
        this.archived = response.data[0]['archived']
        this.last_name = response.data[0]['last_name']
        this.first_name = response.data[0]['first_name']
        this.middle_name = response.data[0]['middle_name']
        this.full_name = response.data[0]['full_name']
        this.birth_last_name = response.data[0]['birth_last_name']
        this.birth_first_name = response.data[0]['birth_first_name']
        this.birth_middle_name = response.data[0]['birth_middle_name']
        this.place_of_birth = response.data[0]['place_of_birth']
        this.country_of_birth = response.data[0]['country_of_birth']
        this.birthdate = response.data[0]['birthdate']
        this.nationality = response.data[0]['nationality']
        this.gender = response.data[0]['gender']
        this.tax_code = response.data[0]['tax_number']
        this.no_tax = response.data[0]['no_tax']
        this.education = response.data[0]['qualification']
        this.mother_last_name = response.data[0]['mother_last_name']
        this.mother_first_name = response.data[0]['mother_first_name']
        this.mother_middle_name = response.data[0]['mother_middle_name']
        this.email1 = response.data[0]['email1']
        this.phone1 = response.data[0]['phone1']
        this.identity_card_number = response.data[0]['identity_card_number']
        this.description = response.data[0]['description']
        this.per_country = response.data[0]['per_country']
        this.per_zip = response.data[0]['per_zip']
        this.per_city = response.data[0]['per_city']
        this.per_type_of_public_premises = response.data[0]['per_type_of_public_premises']
        this.per_public_premises = response.data[0]['per_public_premises']
        this.per_house_number = response.data[0]['per_house_number']
        this.per_building_number = response.data[0]['per_building_number']
        this.per_stairway_number = response.data[0]['per_stairway_number']
        this.per_floor_number = response.data[0]['per_floor_number']
        this.per_door_number = response.data[0]['per_door_number']
        this.temp_country = response.data[0]['temp_country']
        this.temp_zip = response.data[0]['temp_zip']
        this.temp_city = response.data[0]['temp_city']
        this.temp_type_of_public_premises = response.data[0]['temp_type_of_public_premises']
        this.temp_public_premises = response.data[0]['temp_public_premises']
        this.temp_house_number = response.data[0]['temp_house_number']
        this.temp_building_number = response.data[0]['temp_building_number']
        this.temp_stairway_number = response.data[0]['temp_stairway_number']
        this.temp_floor_number = response.data[0]['temp_floor_number']
        this.temp_door_number = response.data[0]['temp_door_number']
        this.bill_country = response.data[0]['bill_country']
        this.bill_zip = response.data[0]['bill_zip']
        this.bill_city = response.data[0]['bill_city']
        this.bill_type_of_public_premises = response.data[0]['bill_type_of_public_premises']
        this.bill_public_premises = response.data[0]['bill_public_premises']
        this.bill_house_number = response.data[0]['bill_house_number']
        this.bill_building_number = response.data[0]['bill_building_number']
        this.bill_stairway_number = response.data[0]['bill_stairway_number']
        this.bill_floor_number = response.data[0]['bill_floor_number']
        this.bill_door_number = response.data[0]['bill_door_number']
        this.bill_name = response.data[0]['billing_name']
        this.taxcode = response.data[0]['taxcode']
        this.okirat_type =  response.data[0]['identity_card_type']
        this.address_card_number = response.data[0]['address_card_number']
        this.parent_phone =  response.data[0]['parent_phone']
        this.parent_email = response.data[0]['parent_email']
        this.registration_date = response.data[0]['registration_date'];
        if (this.bill_name) {
          this.billing_address = true
        } else {
          this.billing_address = false
        }

      }, (error) => {
        this.error_text = error.data
      })
    },
    saveStudent: async function() {
      store.state.showing.preloader = true
      await this.gettoken()
      this.$http.post('/diakok/save_student_20220310', {
        token: this.token,
        customer_id: this.customer_id,
        title: this.title,
        last_name: this.last_name,
        first_name: this.first_name,
        middle_name: this.middle_name,
        birth_last_name: this.birth_last_name,
        birth_first_name: this.birth_first_name,
        birth_middle_name: this.birth_middle_name,
        place_of_birth: this.place_of_birth,
        country_of_birth: this.country_of_birth,
        birthdate: this.birthdate,
        nationality: this.nationality,
        gender: this.gender,
        tax_number: this.tax_code,
        no_tax: this.no_tax,
        qualification: this.education,
        mother_last_name: this.mother_last_name,
        mother_first_name: this.mother_first_name,
        mother_middle_name: this.mother_middle_name,
        email1: this.email1,
        phone1: this.phone1,
        per_country: this.per_country,
        per_zip: this.per_zip,
        per_city: this.per_city,
        per_type_of_public_premises: this.per_type_of_public_premises,
        per_public_premises: this.per_public_premises,
        per_house_number: this.per_house_number,
        per_building_number: this.per_building_number,
        per_stairway_number: this.per_stairway_number,
        per_floor_number: this.per_floor_number,
        per_door_number: this.per_door_number,
        temp_country: this.temp_country,
        temp_zip: this.temp_zip,
        temp_city: this.temp_city,
        temp_type_of_public_premises: this.temp_type_of_public_premises,
        temp_public_premises: this.temp_public_premises,
        temp_house_number: this.temp_house_number,
        temp_building_number: this.temp_building_number,
        temp_stairway_number: this.temp_stairway_number,
        temp_floor_number: this.temp_floor_number,
        temp_door_number: this.temp_door_number,
        identity_card_number: this.identity_card_number,
        description: this.description,
        okirat_type: this.okirat_type,
        address_card_number: this.address_card_number,
        bill_country: this.bill_country,
        bill_zip: this.bill_zip,
        bill_city: this.bill_city,
        bill_public_premises: this.bill_public_premises,
        bill_type_of_public_premises: this.bill_type_of_public_premises,
        bill_house_number: this.bill_house_number,
        bill_building_number: this.bill_building_number,
        bill_stairway_number: this.bill_stairway_number,
        bill_floor_number: this.bill_floor_number,
        bill_door_number: this.bill_door_number,
        bill_name: this.bill_name,
        billing_address: this.billing_address,
        taxcode: this.taxcode,
        parent_email: this.parent_email,
        parent_phone: this.parent_phone
      }).then((response) => {
        store.state.showing.preloader = false
        this.student_save_result = response.data['message']
        this.student_save_success = response.data['success']
        this.create_student_snackbar = true
        if (response.data['success']) {
          this.customer_id = response.data['id']
          this.getStudentDetails()
          //this.pallaszCheck()
        }
      }, (error) => {
        this.student_save_result = error.data
        console.log(error.data);
      })
    },
    deleteStudent: async function() {
      if (confirm("Biztosan törölni szeretné?")) {
      store.state.showing.preloader = true
      await this.gettoken()
      this.$http.post('/diakok/delete_student', {
        token: this.token,
        new_customer_id: this.new_customer_id,
      }).then((response) => {
        this.$eventBus.$emit('delete_student_result', false);
        store.state.showing.preloader = false
        store.state.showing.DiakokDetails_show = false
        store.state.showing.Diakok_show = true
        this.student_delete_result = response.data

      }, (error) => {
        console.log(error.data);
      })
    }
    },
    archiveStudent: async function(archived) {
      store.state.showing.preloader = true
      await this.gettoken()
      this.$http.post('/diakok/archive_student', {
        token: this.token,
        customer_id: this.customer_id,
        archived: archived,
      }).then((response) => {
        store.state.showing.preloader = false
        this.student_save_result = response.data
        this.create_student_snackbar = true
        this.student_save_success = true;
        this.getStudentDetails()
      }, (error) => {
        console.log(error.data);
      })
    },
    getPubpermises: async function() {
      store.state.showing.preloader = true
      await this.gettoken()
      this.$http.post('/diakok/pubpermises', {
        token: this.token,
      }).then((response) => {
        store.state.showing.preloader = false
        this.publicpermises = response.data
        //
      }, (error) => {
        console.log(error.data);
      })
    },
    getPerCityName: async function(irsz) {
      this.per_city_load = true
      await this.gettoken()
      this.$http.post('/diakok/irsz_list', {
        token: this.token,
        irsz: irsz
      }).then((response) => {
        this.per_city_load = false
        this.per_city = response.data[0]['place']
      }, (error) => {
        console.log(error.data);
      })
    },
    getTempCityName: async function(irsz) {
      this.temp_city_load = true
      await this.gettoken()
      this.$http.post('/diakok/irsz_list', {
        token: this.token,
        irsz: irsz
      }).then((response) => {
        this.temp_city_load = false
        this.temp_city = response.data[0]['place']
      }, (error) => {
        console.log(error.data);
      })
    },
    getBillCityName: async function(irsz) {
      this.bill_city_load = true
      await this.gettoken()
      this.$http.post('/diakok/irsz_list', {
        token: this.token,
        irsz: irsz
      }).then((response) => {
        this.bill_city_load = false
        this.bill_city = response.data[0]['place']
      }, (error) => {
        console.log(error.data);
      })
    },
    getCountryList: async function() {
      store.state.showing.preloader = true
      await this.gettoken()
      this.$http.post('/diakok/country_list', {
        token: this.token,
      }).then((response) => {
        store.state.showing.preloader = false
        this.country_list = response.data
        //
      }, (error) => {
        console.log(error.data);
      })
    },
    nationalityList: async function() {
      store.state.showing.preloader = true
      await this.gettoken()
      this.$http.post('/diakok/nationality_list', {
        token: this.token,
      }).then((response) => {
        store.state.showing.preloader = false
        this.nationality_list = response.data
        //
      }, (error) => {
        console.log(error.data);
      })
    },
    gkiPortalReg: async function() {
      store.state.showing.preloader = true
      await this.gettoken()
      this.$http.post('/diakok/gki_portal_reg', {
        token: this.token,
        mail: this.email1,
        birthdate: this.birthdate,
        full_name: this.full_name,
        firstname: this.first_name,
        lastname: this.last_name
      }).then((response) => {
        this.student_save_result = response.data['message']
        this.student_save_success = response.data['success']
        this.create_student_snackbar = true
        store.state.showing.preloader = false
      }, (error) => {
        console.log(error.data);
      })
    },
    OkiratType: async function() {
      store.state.showing.preloader = true
      this.$http.get('/wsdl/OkiratType').then((response) => {
        store.state.showing.preloader = false
        this.okirat_types = response.data
      }, (error) => {
        console.log(error.data);
      })
    },
    validate () {
      this.$refs.diak_adat_form.validate()
      },
    reset () {
      this.$refs.diak_adat_form.reset()
    },
    resetValidation () {
      this.$refs.diak_adat_form.resetValidation()
    },
    scrollToTop() {
     window.scrollTo(0,0);
   },
    copyBirthName() {
      this.birth_last_name = this.last_name
      this.birth_first_name = this.first_name
      this.birth_middle_name = this.middle_name
    },
    copyAddress() {
      this.temp_country = this.per_country
      this.temp_zip = this.per_zip
      this.temp_city = this.per_city
      this.temp_type_of_public_premises = this.per_type_of_public_premises
      this.temp_public_premises = this.per_public_premises
      this.temp_house_number = this.per_house_number
      this.temp_building_number = this.per_building_number
      this.temp_stairway_number = this.per_stairway_number
      this.temp_floor_number = this.per_floor_number
      this.temp_door_number = this.per_door_number
    },
    preSearch: async function() {
     if (this.last_name && this.first_name && !this.customer_id) {
      await this.gettoken()
      this.$http.post('/diakok/diakok_presearch', {
        token: this.token,
        nev: this.full_name
      }).then((response) => {
        this.existing_students = response.data
        if (this.existing_students != '') {
          this.presearch_sheet = true
        }
      }, (error) => {
        console.log(error.data);
      })
     }
    },
    selectFromPresearch(customer_id) {
      this.customer_id = customer_id
      this.presearch_sheet = false
    },
    pallaszCheck: async function() {
      store.state.showing.preloader = true
      await this.gettoken()
      this.$http.post('/diakok/pallasz/pallasz_check', {
        token: this.token,
        customer_id: this.customer_id
      }).then((response) => {
        console.log(response.data);
        store.state.showing.preloader = false
        if (response.data['success'] == true) {
          this.pallasz_dialog = true
          this.pallasz_ids = response.data['pallasz']
        }
      }, (error) => {
        console.log(error.data);
      })
    },
    pallaszUpdate: async function(pallasz_id, course_data_id) {
      this.preloader = true
      await this.gettoken()
      this.$http.post('/diakok/pallasz/gki_jellap_update_personal', {
        token: this.token,
        course_data_id: course_data_id,
        //course_id: this.course_id,
        contract_id: this.contract_id,
        customer_id: this.customer_id,
        pallasz_id: pallasz_id
      }).then((response) => {
        this.preloader = false
        this.student_save_result = response.data['message']
        this.student_save_success = response.data['result']
        this.create_student_snackbar = true
        if (response.data['result'] == 'success') {
          this.pallasz_dialog = false
        }
      }, (error) => {
        console.log(error.data);
      })
    },
    pallaszOkmUpdate: async function(pallasz_id, course_data_id) {
      this.preloader = true
      await this.gettoken()
      this.$http.post('/diakok/pallasz/gki_jellap_update_docs', {
        token: this.token,
        course_data_id: course_data_id,
        contract_id: this.contract_id,
        customer_id: this.customer_id,
        pallasz_id: pallasz_id
      }).then((response) => {
        this.preloader = false
        this.student_save_result = response.data['message']
        this.student_save_success = response.data['result']
        this.create_student_snackbar = true
      }, (error) => {
        console.log(error.data);
      })
    }
  },
  mounted() {
    this.getPubpermises();
    this.getCountryList();
    this.nationalityList();
    this.getStudentDetails()
    this.OkiratType()
    this.validate()
  },
  updated() {

  },
  watch: {
    customer_id: function (value) {
        this.scrollToTop()
        this.getStudentDetails()
        this.validate()
    },
    studentdetails: function (value) {
      if (value) {
        if (!value[0]['last_name'] && !value[0]['first_name']) {
          this.resetValidation()
        }
      }
    },
    no_tax(value) {
      if (value == true) {
        this.tax_code = null
      }
      this.$refs.diak_adat_form.validate()
    },
    foreign_number() {
      this.$refs.diak_adat_form.validate()
    }
  },
  computed: {
    ...mapFields([
      'showing.preloader',
      'showing.DiakokDetails_show',
      'showing.Diakok_show',
      'diakok_details.archived',
      'diakok_details.customer_id',
      'diakok_details.contract_id',
      'diakok_details.contract_type',
      'diakok_details.full_name',
      'diakok_details.birthdate',
      'diakok_details.phone1',
      'diakok_details.email1',
    ]),
    FullName: function (value) {
      if (!this.customer_id) {
        value = this.last_name + " " + this.first_name
      } else {
        value = this.full_name
      }
      this.full_name = value
      return this.full_name
    },
    check18() {
      if (this.registration_date == '') {
        this.registration_date = new Date().toISOString().substr(0, 10);
      }
      var date1 = new Date(this.registration_date);
      var date2 = new Date(this.birthdate);
      var dateMinus18 = date1.setFullYear(date1.getFullYear() - 18);
      if (date2 <= dateMinus18) {
        return true;
      } else {
        return false;
      }
    }
  },
}
</script>

<style lang="scss">
</style>
